import { Icon } from '../Icon';
import React from 'react';

type Props = {
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
  circle?: boolean;
  outline?: boolean;
  icon: string;
  iconColor?: string;
  transparent?: boolean;
  color?: string;
  size?: string;
  className?: string;
  /** アイコンだけのボタンに読み上げ名を付ける。 */
  ariaLabel?: string;
};

export function IconButton({
  onClick,
  disabled = false,
  circle = true,
  outline,
  icon,
  color = 'primary',
  transparent,
  size,
  iconColor,
  className: classProp,
  ariaLabel,
}: Props) {
  const className = React.useMemo(() => {
    let temp = `inline-flex items-center`;
    if (!transparent) {
      temp += outline
        ? ` border border-${color} hover:bg-${color}`
        : ` bg-${color}`;
    }
    if (size) {
      temp += ` ${size}`;
    }
    if (disabled) {
      temp += ` opacity-50`;
    }
    temp += ` ${circle ? 'rounded-full' : 'rounded-md'}`;
    temp += ` ${classProp}`;
    return temp;
  }, [outline, circle, color, size, transparent, disabled, classProp]);

  return (
    <button
      type="button"
      className={className}
      disabled={disabled}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <Icon icon={icon as any} color={iconColor} />
    </button>
  );
}
